// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1P7dZ","colMin":"styles_colMin__Mj4KE","colCheckbox":"styles_colCheckbox__2On9L"};